import React from 'react'
import about1 from  './images/about1.png';
import about2 from  './images/about2.png';
import about3 from  './images/about3.png';

export default function () {
  return (
    <div>
        <section id="about" className="container row mt-5 mb-5 mx-auto ">
  <div className="col-md-4  d-md-flex flex-md-row   gap-md-2 my-3 text-center    ">
    <img src={about1} className="mx-2 about-img" alt="" />
    <h3>
      Parking Facility{" "}
      <p className=" fs-6">
        Fully layered dolor adipisicing elit facere, nobis, id expedita.
      </p>
    </h3>
  </div>
  <div className="col-md-4  d-md-flex flex-md-row   gap-md-2 my-3 text-center   ">
    <img src={about2} className="mx-2 about-img" alt="" />
    <h3>
      Parking Facility{" "}
      <p className=" fs-6">
        Fully layered dolor adipisicing elit facere, nobis, id expedita.
      </p>
    </h3>
  </div>
  <div className="col-md-4  d-md-flex flex-md-row   gap-md-2 my-3 text-center    ">
    <img src={about3} className="mx-2 about-img" alt="" />
    <h3>
      Parking Facility{" "}
      <p className=" fs-6">
        Fully layered dolor adipisicing elit facere, nobis, id expedita.
      </p>
    </h3>
  </div>
</section>

  </div>
  )
}
